module.exports = __webpack_public_path__ + "img/59.b60da4b6.jpg";